import TrainingCoursesCalendar from "training-courses/TrainingCoursesCalendar";
import { handleFilters } from "util/filters";
import Page from "webPage/Page";

Page.register('/training-courses/calendar/?', () => {
    new TrainingCoursesCalendar($(".js-calendar"), $(".js-training-courses-filters"));
    handleFilters();
});
